import { error as logError } from '../utils/logger'
import { apiUrl } from '../config/config'
import { getAuthToken } from '../utils/functions.utils'
interface PropsGetTrainigCourses {
    authToken: string
    version?: string | null
    device_key?: string
}
export const request_get_training_courses_home = async ({ authToken, version, device_key }: PropsGetTrainigCourses) => {
    const URL = apiUrl + '/get_training_courses_home'
    try {
        let response = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: authToken,
                version: version,
                device_key: device_key,
            },
        })
        if (response.status === 401) {
            // Intento de recuperación: refrescar token y reintentar una vez
            const newToken = await getAuthToken('courses_service_retry')
            if (newToken) {
                response = await fetch(URL, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: newToken,
                        version: version,
                        device_key: device_key,
                    },
                })
            }
        }
        if (response.ok) {
            const data = await response.json()
            return data
        } else {
            const errorText = await response.text()
            // Si seguimos sin autorización, devolver estructura mínima para no romper la UI cuando no hay token aún
            if (response.status === 401) {
                return { status: 0, single: { categories: [], data_version: null } } as any
            }
            throw new Error(
                `Error al realizar la solicitud request_get_training_courses_home: ${response.status} - ${response.statusText}: ${errorText}`,
            )
        }
    } catch (error) {
    logError('CoursesService', 'request_get_training_courses_home failed', error)
        throw error
    }
}
